import UpdateUserReferralCode from './Update';

export default UpdateUserReferralCode;
